import { Pagination } from "@/types/pagination";

export const orderByArray = [
  "first_name",
  "public_profile_type",
  "vf_directory_visits",
  "google_visits",
  "marketing_tools_visits",
  "influenced",
  "recommenders",
  "id",
  "enquiry_id",
  "adviser_name",
  "customer_name",
  "customer_email",
  "customer_phone",
  "created_at",
  "submitted_at",
  "type",
  "multiple_answer_choices",
  "professional_full_name",
  "customer_first_name",
  "overall_rating",
  "answer",
  'recommendations_per_client',
  'consumer_duty_risk_markers_percent',
  'prospect_conversion_score',
  'first_name',
  'email',
  'public_profile_type',
  'elevation',
  'full_name',
  'review_count',
  'first_impression_count',
  'review_invitation_count',
  'response_rate',
  'review_invite_last_created',
  'last_review_date',
  'last_login_date',
  'elevation',
  'verified_billing_type',
  'elevation_billing_type',
  "review_count",
  "first_impression_count",
  "name",
  "review_invite_count",
  "response_rate",
  "question_label",
  'overall_rating_current_year',
  'review_count_current_year',
  'has_public_profile',
  'status',
  "question_label",
  'identified',
  'survey_id',
  'survey_type',
  'client_name',
  'firm_name',
  'date_viewed_action',
  'date_actioned',
  'review_date',
  'actioned_by_firm',
  'actioned_by_adviser',
  'viewed_action',
  'redirect',
  'elevation',
  'verified_billing_type',
  'elevation_billing_type',
  'crm_customer_code',
  'overall_rating_for_year',
  'has_all_advisers_on_elevation',
  'qualifying_advisers_score',
  'risk_score',
  'passionate_advocates_score',
  'client_confidence_score',
  'client_email',
  'client_first_name',
  'professional.full_name',
  'review_count_for_year',
  'send_at',
  'client_crm_sid',
  'review_type',
  'report_type',
  'report_queue_status',
  'report_queue_date_period',
  'service_type',
  'service_type_service_type_name',
  'user',
  'generated_at',
  'invite_type',
  'has_about',
  'has_photo',
  'has_published_fees',
  'min_wealth',
  'min_mortgage',
  'last_published_article_date',
  'last_pinned_review_date',
  'last_faq_date',
  'date',
  'title',
  'status',
  'approved_at',
] as const;

export type OrderByColumn = typeof orderByArray[number];
export type SearchInputFields = 'customer_first_name' | 'customer_email' | 'answer_choice' | 'question_label' | 'redirect' | 'client_email' | 'client_first_name'
export interface OrderBy {
  column: OrderByColumn
  direction: "ASC" | "DESC"
}

export interface FetchParams extends Pagination {
  order_by?: OrderBy,
  professional_id?: number,
  question_id?: number,
  to?: string,
  from?: string,
  tab?: string
  redirect?: string
}

export type FetchParamsWithRequiredOrderBy = Omit<FetchParams, 'order_by' | 'redirect'> & {
  order_by: OrderBy
}

export const defaultFetchParams: Omit<FetchParams, 'redirect'> = {
  limit: 100000,
  offset: 0,
  order_by: {
    column: 'id',
    direction: 'ASC',
  },
}

export interface FetchParamsWithoutPagination {
  order_by?: OrderBy,
  professional_id?: number,
  question_id?: number,
  tab?: string
}